import translation from 'shared/strings';

function isUSZipcode(value) {
  const regex = /(^\d{5}(-\d{4})?$)/;

  return regex.test(value);
}

function isValidUSZip(value, region) {
  const isValid = isUSZipcode(value);

  if (!isValid) {
    return translation.ERROR_US_ZIP_CODE[region];
  }
  return false;
}

function isEmpty(value, region) {
  const regex = /^$/;
  const isValid = regex.test(value);

  if (isValid) {
    return translation.ERROR_REQUIRED_FIELD[region];
  }
  return false;
}

function isValidEmail(value, region) {
  const isValid = email(value);

  if (!isValid) {
    return translation.ERROR_VALID_EMAIL[region];
  }
  return false;
}

function email(value) {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return regex.test(value);
}

function number(value) {
  const regex = /^[0-9]*$/;

  return regex.test(value);
}

function isBlank(value) {
  const regex = /^\s*$/;

  return regex.test(value);
}

function isValidUSPhone(value) {
  const regex = /^(((\+)|(00))?1)?([0-9]{10})$/;

  return regex.test(value);
}

function isValidCNPhone(value) {
  const regex = /^[0-9]{11}$/;

  return regex.test(value);
}

export default {
  isValidUSZip,
  isEmpty,
  isValidEmail,
  email,
  number,
  isBlank,
  isValidUSPhone,
  isUSZipcode,
  isValidCNPhone
};
